<template > 
  <transition>
    <div id="firebase-interface" class="inactive">
      <div id="container">  
        <div ref="loaded" class="hidden">
          <div id="main">
            <div ref="userSignedIn" class="hidden">
              <!-- <div id="user-info">
                <div id="photo-container">
                  <img ref="photo">
                </div>
                <div ref="name"></div>
                <div ref="email"></div>
                <div ref="phone"></div>
                <div id="is-new-user"></div>
                <div class="clearfix"></div>
              </div>
              <p>
                <button id="sign-out" v-on:click="onSignOut">Sign Out</button>
                <button id="delete-account" v-on:click="onDeleteAccount">Delete account</button>
              </p> -->
            </div>
            <div ref="userSignedOut"  class="hidden"> 
              <div ref="firebaseui"></div>
            </div>
          </div>
        </div>
      </div>
    </div> 
  </transition>

</template>

<script>

import { mapState, mapMutations } from 'vuex'; 
import FirebaseService from '@/services/FirebaseService' 
import Raf from '@/helpers/Raf' 
import store from '@/store';

export default {

  name: 'firebase-interface',
  
  components: {  },
  
  data() {
    return {}
  },
  
  computed: {
    ...mapState('app', ['y', 'auth'])
  },
  
  mounted() {
    this.setup();
  },
  
  beforeDestroy() {},
  
  methods: { 

    ...mapMutations('app', [
      'login',
      'logout'
     ]),

    setup(){

      let config = {
        apiKey: "AIzaSyCwys3GCnWkSCcMFQGSOJb31GZui0cTOyo",
        projectId: "project-doom-666",
        authDomain: "project-doom-666.firebaseapp.com",
        databaseURL: "project-doom-666.firebaseio.com/", 
        CLIENT_ID: '1039852809948-0deooasrjh1ca20g1h6picirjgs5u5si.apps.googleusercontent.com',
        signInOpts: { 
          google: true 
        }
      }

      if( this.auth ){
        this.firebase = new FirebaseService(config); 
        this.firebase.on(FirebaseService.Events.USER_SIGN_OUT, this.onUserSignOut);
        this.firebase.on(FirebaseService.Events.USER_SIGN_IN, this.onUserSignIn);
      } else {

        //login without user data
        this.login({
          uid: null
        }); 
      }

    },

    onTick(){ 
      let mult = 3;
      this.$el.style.transform = 'translate3d(0, '+( (this.y * mult) + (mult * 900))+'px, 0)'
    },

    onAuthStateChange(event){
      this.$refs.loading.style.display = 'none';
      this.$refs.loaded.style.display = 'block'; 
      console.log('onAuthStateChange :: ', event)
    }, 

    onSignInRedirect(){
      this.firebase.signInWithRedirect();
    },

    onSignInPopup(){
      this.firebase.signInWithPopup();
    },

    onSignOut(){ 
      this.firebase.signOut();
    },

    onUserSignIn(user){

      this.login({
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,  
        photoURL: user.photoURL
      });

    },

    onUserSignOut(config){

      this.logout();

      // this.$refs.userSignedIn.style.display = 'none';
      // this.$refs.userSignedOut.style.display = 'block';
      this.firebase.ui.start(this.$refs.firebaseui, config); 
    },

    onDeleteAccount(){
      this.firebase.deleteAccount();
    },

    onRecaptchaConfigChange(){
      this.firebase.handleRecaptchaConfigChange();
    } 

  },
  
  watch: {
 
    '$route'(val){
      if(val.name === 'intro'){ 
        Raf.add(this.onTick)
        this.$el.classList.remove('inactive');
      } else { 
        Raf.remove(this.onTick)
      }
    }
  }

}

</script>

<style lang="sass" >
@import "src/styles/common.sass"

#firebase-interface
  position: absolute;
  bottom: 0;
  width: 100%;

  &.inactive
    pointer-events: none;
    opacity: 0;

  .firebaseui-container
    font-family: 'Courier Prime';
    max-width: 500px;

  .firebaseui-tos
    color: black;

  .firebaseui-card-content
    padding: 0 24px;

</style>